import InfoButton from "./InputInfobutton";
export default InfoButton;
